<template>
    <div class="usdt_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.push('/user')"></div>
            <div class="big_tit">{{data.payment.name}}</div>
        </div>

        <!-- 状态栏：仅加密货币通道显示 -->
        <div class="status_bar" v-if="data.payment && data.payment.type == 1">
            <div class="countdown" :class="{ near_expiry: nearExpiry, expired_time: isExpired }">
                ⏱ {{ remainingTime }}
            </div>
        </div>

        <!-- 主卡片 -->
        <div class="code_box">
            <!-- 金额区 -->
            <div class="amount_section">
                <div class="amount_label" v-if="data.payment && data.payment.type == 1">{{ data.payment.mark }}-{{ money }}</div>
                <div class="amount_label" v-else>{{ money }}</div>
                <div class="amount_row" v-if="data.payment && data.payment.type == 1 && data.money2">
                    <span class="amount_num">{{ displayMoney2 }}</span>
                    <span class="amount_unit">{{ data.payment.mark }}</span>
                    <span class="copy_amount_btn"
                          v-clipboard="() => displayMoney2"
                          v-clipboard:success="onAmountCopied">
                        {{ amountCopied ? $t('invest_qrcode.amountCopied') : $t('invest_qrcode.copyAmount') }}
                    </span>
                </div>
                <div class="amount_approx" v-if="data.payment && data.payment.type != 1">{{ actualAmount }}</div>
                <div class="order_id" v-if="data.orderid">{{$t('invest_qrcode.orderId')}}{{ data.orderid }}</div>
            </div>

            <!-- 扫码提示（加密货币） -->
            <div class="scan_tip" v-if="data.payment.type==1">{{$t('invest_qrcode.scanQRcode')}}</div>

            <!-- 二维码 -->
            <div class="qrcode_img">
                <img class="qrcode" :src="data.payment.qrcode" alt="收款二维码"
                     @error="qrFailed = true" v-show="!qrFailed" />
                <div v-if="qrFailed" class="qr_placeholder">{{$t('invest_qrcode.qrLoadFailed')}}</div>
            </div>

            <!-- 网络/币种信息（加密货币） -->
            <template v-if="data.payment && data.payment.type == 1">
                <div class="network_info">
                    <div class="info_row" v-if="data.payment.network">
                        <span class="info_label">{{$t('invest_qrcode.networkLabel')}}</span>
                        <span class="info_value">{{ data.payment.network }}</span>
                    </div>
                    <div class="info_row">
                        <span class="info_label">{{$t('invest_qrcode.currencyLabel')}}</span>
                        <span class="info_value">{{ data.payment.name }}</span>
                    </div>
                </div>
                <div class="wallet">{{$t('invest_qrcode.walletAddress')}}</div>
                <div class="walletAddress">{{data.payment.address}}</div>
            </template>
        </div>

        <!-- 复制地址按钮（加密货币） -->
        <div class="copy_addr_btn" v-if="data.payment && data.payment.type==1"
             v-clipboard="() => data.payment.address"
             v-clipboard:success="copy">
            <span class="copy_addr_icon">📋</span>
            <span>{{$t('invest_qrcode.copyWalletAddress')}}</span>
        </div>

        <!-- 注意事项（加密货币） -->
        <div class="warning_box" v-if="data.payment && data.payment.type == 1">
            <div class="warning_title">{{$t('invest_qrcode.warningTitle')}}</div>
            <div class="warning_item" v-html="$t('invest_qrcode.warningItem1')"></div>
            <div class="warning_item">· 仅支持 <strong>{{ data.payment.name }}{{ data.payment.network ? '（' + data.payment.network + '）' : '' }}</strong> 网络，切勿发送到其他网络</div>
            <div class="warning_item">{{$t('invest_qrcode.warningItem3')}}</div>
        </div>

        <!-- 操作区：加密货币通道 -->
        <template v-if="data.payment && data.payment.type == 1">
            <!-- 未点击已付款：显示主按钮 -->
            <div class="basic_btn" @click="onMarkPaid" v-if="!isPaid">
                {{$t('invest_qrcode.markPaidBtn')}}
            </div>
            <!-- 已点击已付款：显示检测状态 -->
            <div class="polling_box" v-else>
                <div class="polling_icon">⏳</div>
                <div class="polling_text">{{$t('invest_qrcode.pollingText')}}</div>
                <div class="polling_sub">{{$t('invest_qrcode.pollingSub')}}</div>
                <div class="polling_kefu" @click="$router.push('/kefu')">{{$t('invest_qrcode.pollingKefu')}}</div>
            </div>
        </template>

        <!-- 操作区：非加密货币通道（保持原有逻辑） -->
        <div class="basic_btn" @click="submitBtn" v-if="data.payment.type && data.payment.type != 1">
            {{$t('utils.submit')}}
        </div>

        <!-- 超时蒙层（轮询在后台继续运行，到账后自动跳转） -->
        <div class="expired_mask" v-if="isExpired && data.payment && data.payment.type == 1">
            <div class="expired_icon">⏰</div>
            <h3 class="expired_title">{{$t('invest_qrcode.orderExpired')}}</h3>
            <p class="expired_desc">{{$t('invest_qrcode.expiredDesc')}}</p>
            <p class="expired_sub">{{$t('invest_qrcode.expiredSub')}}</p>
            <div class="basic_btn" @click="$router.push('/invest')">{{$t('invest_qrcode.rechargeAgain')}}</div>
            <div class="kefu_btn" @click="$router.push('/kefu')">{{$t('invest_qrcode.contactKefu')}}</div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
    import Api from "../../interface/index";
    import bsHeader from '../../components/bsHeader.vue'
    import Clipboard from 'v-clipboard';
    Vue.use(Clipboard);
    export default {
        name: "invest_qrcode",
        data() {
            return {
                // ===== 原有字段（保留）=====
                data: { payment: {} },
                money: 0,
                actualAmount: '',
                // ===== 新增字段 =====
                pollTimer: null,
                countdownTimer: null,
                now: Date.now(),
                createdAt: 0,   // 客户端收到订单响应的时间戳，用于倒计时（规避服务器时区问题）
                pollFailCount: 0,
                isPaid: false,
                isRedirecting: false,  // 防止并发 checkStatus 双重跳转
                qrFailed: false,
                amountCopied: false,
            };
        },
        computed: {
            // 去掉 money2 尾随零，方便用户在钱包输入（200.010000 → 200.01）
            displayMoney2() {
                if (!this.data.money2) return '';
                return String(this.data.money2).replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '');
            },
            remainingTime() {
                if (!this.createdAt) return '--:--';
                const deadline = this.createdAt + 20 * 60 * 1000;
                const diff = deadline - this.now;
                if (diff <= 0) return '00:00';
                const m = Math.floor(diff / 60000);
                const s = Math.floor((diff % 60000) / 1000);
                return `${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
            },
            isExpired() {
                if (!this.createdAt) return false;
                const deadline = this.createdAt + 20 * 60 * 1000;
                return this.now > deadline;
            },
            nearExpiry() {
                if (!this.createdAt) return false;
                const deadline = this.createdAt + 20 * 60 * 1000;
                return !this.isExpired && (deadline - this.now) < 300000;
            }
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            this.money = this.$route.query.money;  // 必须保留：从路由参数获取金额，缺少此行页面金额为 0
            this.start();
            this.countdownTimer = setInterval(() => { this.now = Date.now(); }, 1000);
        },
        methods: {
            start() {
                Fetch('/user/recharge_type', {
                    money: this.$route.query.money ? this.$route.query.money : "",
                    id: this.$route.query.id ? this.$route.query.id : ""
                }).then((r) => {
                    this.data = r.data;
                    // 用服务器返回的 Unix 时间戳（ms）作为倒计时基准
                    // ts 是 UTC 绝对值，Date.now() 也是 UTC，两者直接比较不受时区影响
                    // 刷新复用旧订单时，ts 是订单真实创建时间，倒计时不会重置
                    this.createdAt = r.data.ts ? r.data.ts * 1000 : Date.now();
                    this.changeAmount();
                    // 加密货币通道：订单创建后立即自动开始轮询，无需用户点击按钮
                    // 轮询持续运行直到到账/拒绝/离开页面，不在 20 分钟时停止
                    // 原因：cron 48 小时内都会匹配，用户超时后付款仍可自动跳转
                    if (r.data && r.data.payment && r.data.payment.type == 1) {
                        this.checkStatus();
                        this.pollTimer = setInterval(() => this.checkStatus(), 5000);
                    }
                });
            },
            // 非加密货币通道提交（原有逻辑，保留不变）
            submitBtn() {
                Fetch("/user/recharge_apply", {
                    id: this.data.orderId
                }).then((r) => {
                    if (r.code == 1) {
                        this.$toast({
                            background: "#07c160",
                            message: this.$t('invest_qrcode.submittedSuccessfully'),
                        });
                        this.$router.replace("/moneybag");
                    }
                });
            },
            // 加密货币通道：用户点击"我已完成转账"，仅通知后端 status 3→0
            // 轮询已在订单创建时自动启动，此处不重复开启
            async onMarkPaid() {
                this.isPaid = true;
                this.pollFailCount = 0;  // 重置失败计数
                try {
                    await Fetch('/user/recharge_apply', { id: this.data.orderId }, {}, false);
                } catch (e) {}
                // 如果轮询已停止（网络恢复后用户手动触发），重启轮询
                if (!this.pollTimer) {
                    this.checkStatus();
                    this.pollTimer = setInterval(() => this.checkStatus(), 5000);
                }
            },
            async checkStatus() {
                try {
                    const res = await Fetch('/user/check_recharge_status', {
                        id: this.data.orderId,
                    }, {}, false);
                    this.pollFailCount = 0;
                    if (res.data.status === 'success') {
                        if (this.isRedirecting) return;
                        this.isRedirecting = true;
                        this.stopPolling();
                        this.$router.replace('/moneybag');
                    } else if (res.data.status === 'rejected') {
                        this.stopPolling();
                        this.$toast(this.$t('invest_qrcode.orderRejected'));
                        this.isPaid = false;
                    }
                    // pending：继续轮询，不做任何操作
                } catch (e) {
                    this.pollFailCount++;
                    if (this.pollFailCount >= 6) {
                        this.stopPolling();
                        this.isPaid = false;  // 统一重置，让按钮恢复可点状态
                        this.$toast(this.$t('invest_qrcode.networkError'));
                    }
                }
            },
            stopPolling() {
                if (this.pollTimer) {
                    clearInterval(this.pollTimer);
                    this.pollTimer = null;
                }
            },
            copy() {
                this.$toast({
                    className: "toastName",
                    message: this.$t('invest_qrcode.copySucceeded'),
                });
            },
            onAmountCopied() {
                this.amountCopied = true;
                this.$toast({ className: "toastName", message: this.$t('invest_qrcode.copySucceeded') });
                setTimeout(() => { this.amountCopied = false; }, 2000);
            },
            changeAmount() {
                if (!this.data.payment) return;
                if (this.data.payment.type == 1) {
                    // 加密货币通道直接使用后端返回的 money2，不在前端计算
                    return;
                }
                var num = 2;
                this.actualAmount = "(≈" + this.data.payment.mark + (this.money / this.data.payment.rate).toFixed(num) + ")";
            }
        },
        beforeDestroy() {
            this.stopPolling();
            if (this.countdownTimer) {
                clearInterval(this.countdownTimer);
                this.countdownTimer = null;
            }
        }
    };
</script>

<style lang="less" scoped>
    .usdt_wrap {
        background: url(../images/login/login_bg.png) no-repeat center top;
        background-size: contain;
        width: 100%;
        min-height: 100%;
        position: fixed;
        top: 0; left: 0; right: 0; bottom: 0;
        overflow-y: auto;
        background-color: #f7f7f7;
        padding-bottom: 40px;
        box-sizing: border-box;
    }
    .red_top_bg {
        background: none;
    }
    /* 状态栏 */
    .status_bar {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 8px 16px;
        background: rgba(255,255,255,0.92);
        margin: 6px 5%;
        border-radius: 6px;
        font-size: 13px;
        box-shadow: 0 1px 4px rgba(0,0,0,0.08);
        .countdown {
            font-size: 15px;
            font-weight: bold;
            color: #333;
            white-space: nowrap;
            flex-shrink: 0;
            &.near_expiry { color: #e82637; }
            &.expired_time { color: #bbb; }
        }
    }
    /* 主卡片 */
    .code_box {
        width: 90%;
        margin-left: 5%;
        padding: 16px 0 10px;
        background: rgba(255,255,255,1);
        box-shadow: 0px 2px 9px 2px rgba(160,160,160,0.15);
        border-radius: 6px;
        margin-top: 6px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .amount_section {
            width: 90%;
            text-align: center;
            margin-bottom: 6px;
        }
        .amount_label {
            font-size: 13px;
            color: #999;
            margin-bottom: 6px;
        }
        .amount_row {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
            flex-wrap: wrap;
        }
        .amount_num {
            font-size: 26px;
            font-weight: bold;
            color: #e82637;
        }
        .amount_unit {
            font-size: 14px;
            color: #666;
            align-self: flex-end;
            margin-bottom: 4px;
        }
        .copy_amount_btn {
            background: #fff3f3;
            color: #e82637;
            border: 1px solid #e82637;
            border-radius: 4px;
            padding: 2px 8px;
            font-size: 12px;
            align-self: center;
        }
        .amount_approx {
            font-size: 13px;
            color: #999;
            margin-top: 4px;
        }
        .order_id {
            font-size: 11px;
            color: #bbb;
            margin-top: 4px;
        }
        .scan_tip {
            font-size: 13px;
            color: #999;
            margin-bottom: 6px;
        }
        .qrcode_img {
            width: 160px;
            height: 160px;
            margin: 0 auto;
            text-align: center;
            background: linear-gradient(to left, #999, #999) left top no-repeat,
                        linear-gradient(to bottom, #999, #999) left top no-repeat,
                        linear-gradient(to left, #999, #999) right top no-repeat,
                        linear-gradient(to bottom, #999, #999) right top no-repeat,
                        linear-gradient(to left, #999, #999) left bottom no-repeat,
                        linear-gradient(to bottom, #999, #999) left bottom no-repeat,
                        linear-gradient(to left, #999, #999) right bottom no-repeat,
                        linear-gradient(to left, #999, #999) right bottom no-repeat;
            background-size: 1px 16px, 16px 1px, 1px 16px, 16px 1px;
            span { line-height: 160px; }
            .qrcode { width: 152px; height: 152px; margin-top: 4px; }
        }
        .qr_placeholder {
            width: 152px;
            height: 152px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            color: #999;
            text-align: center;
            padding: 10px;
            box-sizing: border-box;
        }
        .network_info {
            width: 85%;
            margin: 8px 0 4px;
            background: #f8f8f8;
            border-radius: 6px;
            padding: 7px 12px;
            box-sizing: border-box;
            .info_row {
                display: flex;
                justify-content: space-between;
                align-items: flex-start;  /* 多行时顶对齐 */
                font-size: 12px;
                padding: 3px 0;
                .info_label {
                    color: #999;
                    white-space: nowrap;  /* 标签不换行 */
                    margin-right: 8px;
                    flex-shrink: 0;
                }
                .info_value {
                    color: #333;
                    font-weight: 500;
                    text-align: right;
                    word-break: break-word;  /* 值过长时允许换行 */
                }
            }
        }
        .wallet {
            font-size: 13px;
            color: #999;
            margin-top: 8px;
        }
        .walletAddress {
            text-align: center;
            color: #000;
            width: 80%;
            font-size: 12px;
            word-break: break-all;
            margin-top: 3px;
            margin-bottom: 6px;
            line-height: 1.5;
        }
    }
    /* 复制地址按钮 */
    .copy_addr_btn {
        width: 90%;
        margin: 8px 5% 0;
        min-height: 44px;        /* 改为最小高度，英文换行时自动撑高 */
        padding: 10px 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        background: #fff;
        border: 1px solid #e82637;
        border-radius: 22px;
        color: #e82637;
        font-size: 14px;
        box-sizing: border-box;
        text-align: center;
        word-break: break-word;
        .copy_addr_icon { font-size: 15px; flex-shrink: 0; }
    }
    /* 注意事项 */
    .warning_box {
        width: 90%;
        margin: 8px 5% 0;
        background: #fffbf0;
        border: 1px solid #ffe58f;
        border-radius: 6px;
        padding: 8px 12px;
        box-sizing: border-box;
        .warning_title {
            font-size: 13px;
            font-weight: bold;
            color: #d48806;
            margin-bottom: 4px;
        }
        .warning_item {
            font-size: 11px;
            color: #595959;
            line-height: 1.7;
            word-break: break-word;  /* 英文长单词允许换行 */
        }
    }
    /* 检测中状态框 */
    .polling_box {
        width: 90%;
        margin: 10px 5% 0;
        background: #fff;
        border-radius: 8px;
        padding: 14px;
        box-sizing: border-box;
        text-align: center;
        box-shadow: 0px 2px 9px 2px rgba(160,160,160,0.15);
        .polling_icon { font-size: 28px; margin-bottom: 6px; }
        .polling_text { font-size: 15px; font-weight: bold; color: #333; }
        .polling_sub { font-size: 12px; color: #999; margin-top: 4px; }
        .polling_kefu {
            font-size: 13px;
            color: #e82637;
            margin-top: 10px;
            text-decoration: underline;
        }
    }
    /* 超时蒙层 */
    .expired_mask {
        position: fixed;
        top: 0; left: 0; right: 0; bottom: 0;
        background: rgba(255,255,255,0.97);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 999;
        padding: 40px;
        box-sizing: border-box;
        .expired_icon { font-size: 60px; margin-bottom: 16px; }
        .expired_title { font-size: 20px; color: #333; margin-bottom: 8px; }
        .expired_desc { font-size: 14px; color: #666; text-align: center; margin-bottom: 4px; line-height: 1.6; }
        .expired_sub { font-size: 13px; color: #999; text-align: center; margin-bottom: 24px; }
        .basic_btn { margin: 8px auto 0; }
    }
    .kefu_btn {
        display: block;
        width: 90%;
        margin: 12px auto 0;
        height: 48px;
        line-height: 48px;
        text-align: center;
        border: 1px solid #e82637;
        color: #e82637;
        border-radius: 50px;
        font-size: 15px;
        box-sizing: border-box;
    }
    .basic_btn {
        margin: 10px auto 0;
    }
</style>
